import React from "react";
import { useLanguage } from "../../Language";
import { useLSSearch } from "./ls/LSSearch";
import { Alert, AlertTitle } from "@mui/material";
import { LSSearchSpellingSuggestions } from "./LSSearchSpellingSuggestions";
import { SanitizedHTML } from "../../SanitizedHTML";

export const NoResultsNotice = () => {
  const { translate } = useLanguage();
  const {
    loadingResults,
    totalHits,
    searchParams: { hasFilters },
  } = useLSSearch();

  const showBaseMsg = !loadingResults && totalHits === 0;
  const showClearFiltersMsg = showBaseMsg && hasFilters;

  if (!showBaseMsg) return null;

  return (
    <>
      {showClearFiltersMsg ? (
        <Alert severity="info">
          <AlertTitle>
            <SanitizedHTML html={translate("noResultsFound")} />
          </AlertTitle>
          {translate("removeFilter")}
        </Alert>
      ) : (
        <Alert severity="info">
          <AlertTitle>
            <SanitizedHTML html={translate("noResultsFound")} />
          </AlertTitle>
          <LSSearchSpellingSuggestions />
        </Alert>
      )}
    </>
  );
};
